/* eslint-disable @typescript-eslint/no-explicit-any */
import { ExtendedColumnDef } from "components/Datatable";
import SortedCell from "./components/sorted-cell";

import { cn } from "../../../../lib/utils";
import { formatToBRL } from "../../../../utils/formatToMoney";

const allClass = () => {
  return cn("w-full h-full px-[10px] py-[6px]");
};

export const columns: ExtendedColumnDef<any>[] = [
  {
    accessorKey: "code",
    header: ({ column }) => (
      <SortedCell key={"code"} column={column} title={"Lojas"} />
    ),
    cell: ({ row }: { row: any }) => {
      return (
        <div className={allClass()}>
          Loja {row.original.code}
        </div>
      );
    },
    className: "!p-0 !w-[576px]",
  },
  {
    accessorKey: "entrance",
    header: "Entradas",
    cell: ({ row }) => (
      <div className={`${allClass()} justify-start flex bg-[#2AB57D33]`}>
        <p className="cursor-pointer">{formatToBRL(row?.original?.entrance)}</p>
      </div>
    ),

    className: "!p-0 !w-[200px]",
  },
  {
    accessorKey: "exists",
    header: "Saídas",
    cell: ({ row }: { row: any }) => {
      return (
        <div className={`${allClass()} justify-start flex  bg-[#FEDCDB]`}>
          <p className="cursor-pointer">{formatToBRL(row?.original?.exists)}</p>
        </div>
      );
    },
    className: "!p-0 !w-[200px]",
  },
  {
    accessorKey: "balance",
    header: ({ column }) => (
      <SortedCell column={column} title={"Valor de Saldo"} key={"balance"} />
    ),
    cell: ({ row }: { row: any }) => {
      return (
        <div className={`${allClass()} justify-start flex bg-[#C1C0FF]`}>
          <p className="cursor-pointer">
            {formatToBRL(row?.original?.balance)}
          </p>
        </div>
      );
    },
    className: "!p-0 !w-[200px]",
  },
  {
    accessorKey: "depositOutput",
    header: "Saída de Depósitos",
    cell: ({ row }: { row: any }) => {
      return (
        <div className={`${allClass()} justify-start flex`}>
          <p className="cursor-pointer">
            {formatToBRL(row?.original?.depositOutput)}
          </p>
        </div>
      );
    },
    className: "!p-0 !w-[200px]",
  },
  {
    accessorKey: "moneyValue",
    header: "Valor de Dinheiro",
    cell: ({ row }: { row: any }) => {
      return (
        <div className={`${allClass()} justify-start flex`}>
          <p className="cursor-pointer">
            {formatToBRL(row?.original?.moneyValue)}
          </p>
        </div>
      );
    },
    className: "!p-0 !w-[200px]",
  },
];
